<template>
  <v-card flat>
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Program Percentage
      </v-toolbar-title>
    </v-app-bar>

    <v-card-text>
      <v-sheet
        v-resize="onResize"
        :height="height"
        id="scrolling-techniques-7"
        class="overflow-y-auto"
      >
        <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
          <v-card>
            <v-virtual-scroll
              :bench="benched"
              :items="testTypes"
              :height="height - 140"
              item-height="64"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ item.name }}</strong>
                      (Drug - {{ item.percentDrug }}%, Drug/ Alcohol -
                      {{ item.percentAlcohol }}%)
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-html="item.description"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn v-if="item.active" icon @click="editType(item.id)">
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      v-else
                      depressed
                      class="red lighten-1"
                      dark
                      @click="typeStatus(item.id, true)"
                    >
                      Inactive
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-container>
      </v-sheet>
    </v-card-text>

    <ProgramForm :visible="showTypeForm" :item="type" @close="closeThis" />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-btn
      class="mx-2"
      fab
      dark
      absolute
      right
      color="indigo"
      style="bottom: 40px;"
      @click="addType()"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import Api from '@/services/Api'
import _ from 'lodash'
import ProgramForm from '../components/forms/Program.vue'

export default {
  name: 'types',

  components: {
    ProgramForm,
  },

  data() {
    return {
      benched: 0,
      editedItem: this.item,
      height: 0,
      saving: false,
      showTypeForm: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
      testTypes: [],
      type: {},
    }
  },

  created() {
    this.getTypes()
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
    },
  },

  watch: {
    editedItem: {
      handler: function() {
        this.saving = true
      },
      deep: true,
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 180
    },

    async getTypes() {
      const clientId = this.$store.state.client.id

      try {
        const response = await Api().get('test_types/' + clientId)

        this.testTypes = response.data
      } catch (e) {
        console.error(e)
      }
    },

    addType() {
      this.showTypeForm = true
      this.type = {}
      this.type.active = true
    },

    editType(id) {
      this.showTypeForm = true
      this.type = _.find(this.testTypes, { id })
    },

    async typeStatus(typeId, active) {
      try {
        let formData = {}
        formData.active = active

        const response = await Api().put('test_type/' + typeId, formData)

        let objIndex = this.testTypes.findIndex(obj => obj.id == typeId)

        this.testTypes[objIndex].active = active

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThis() {
      this.showTypeForm = false
      this.getTypes()
    },
  },
}
</script>

<style></style>
